import { sendXsellDepositMessage } from '@/utilities/helpers/wrapperHelpers';
import { PLATFORMS } from '@/utilities/constants/game';
import { useCallback } from 'react';
import PlusIcon from '@/features/Icons/PlusIcon';
import './styles/addFundsButton.scss';
import useDepositFundsAndReloadBalance from '@/unified-modules/wallet/helpers/useAddFundsAndReloadBalance';
import { useStore } from '@/store/useStore';
interface AddFundsButtonProps {
  isMobile: boolean;
  depositLink: string;
  size?: number;
}

export const AddFundsButton = ({
  size,
  isMobile,
  depositLink,
}: AddFundsButtonProps) => {
  const runtime = useStore((s) => s.runtime);
  const isSpinInProgress = useStore((s) => s.gameWindowContext.spinInProgress);
  const depositFundsAndReloadBalance = useDepositFundsAndReloadBalance();

  const handleDepositButton = useCallback(async () => {
    if (runtime.platform === PLATFORMS.Desktop) {
      await depositFundsAndReloadBalance();
    }
    sendXsellDepositMessage();
  }, [runtime, depositFundsAndReloadBalance]);

  return runtime.platform === PLATFORMS.Desktop ? (
    <button
      className="add-funds-button"
      data-testid="add-funds-button"
      onClick={() => !isSpinInProgress && handleDepositButton()}
    >
      <div className="add-funds-container">
        {
          <PlusIcon
            isMobile={isMobile}
            size={size}
            className={`plus${isSpinInProgress ? ' disabled' : ''}`}
            dataTestId="add-funds-plus"
          />
        }
      </div>
    </button>
  ) : (
    <a
      href={isSpinInProgress ? undefined : depositLink}
      rel="noreferrer"
      target="_blank"
      data-testid="add-funds-button"
      onClick={() => !isSpinInProgress && handleDepositButton()}
    >
      <div className="add-funds-container">
        {
          <PlusIcon
            isMobile={isMobile}
            size={size}
            className={`plus${isSpinInProgress ? ' disabled' : ''}`}
            dataTestId="add-funds-plus"
          />
        }
      </div>
    </a>
  );
};
